export type RuntimeEventFrame = {
  type: "event";
  event: string;
  payload?: unknown;
  seq?: number;
  stateVersion?: { presence: number; health: number };
};

export type RuntimeConnectionSnapshot = {
  readyState: "connecting" | "open" | "closing" | "closed" | "missing";
  url: string;
  hasToken: boolean;
  pendingRequestCount: number;
  lastSeq: number | null;
  pendingConnectError?: { code: string; message: string; details?: unknown };
};

export type RuntimeCloseInfo = {
  code: number;
  reason: string;
  error?: { code: string; message: string; details?: unknown };
};

export type RuntimeGapInfo = {
  expected: number;
  received: number;
};

export type RuntimeDiagnosticEntry = {
  level: "info" | "warn" | "error";
  event: string;
  message: string;
  details?: unknown;
};

export type RuntimeTransportLifecycleOptions = {
  clientName?: string;
  clientVersion?: string;
  platform?: string;
  mode?: string;
  instanceId?: string;
  onHello?: (hello: unknown) => void;
  onEvent?: (event: RuntimeEventFrame) => void;
  onClose?: (info: RuntimeCloseInfo) => void;
  onGap?: (info: RuntimeGapInfo) => void;
  diagnosticLogger?: (entry: RuntimeDiagnosticEntry) => void;
};

export class RuntimeRequestError extends Error {
  readonly runtimeCode: string;
  readonly gatewayCode?: string;
  readonly details?: unknown;

  constructor(code: string, message: string, details?: unknown, gatewayCode?: string) {
    super(message);
    this.name = "RuntimeRequestError";
    this.runtimeCode = code;
    this.gatewayCode = gatewayCode;
    this.details = details;
  }
}

export class RuntimeTransportStoppedError extends Error {
  constructor() {
    super("runtime transport stopped");
    this.name = "RuntimeTransportStoppedError";
  }
}

export type RuntimeTransport = {
  start: () => void;
  stop: () => void;
  request: <T = unknown>(method: string, params?: unknown) => Promise<T>;
  getConnectionSnapshot: () => RuntimeConnectionSnapshot;
};
